// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","617":"component---src-pages-page-2-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"68558625d91e587510d8","617":"36c3d8668d4364591529","678":"207cc48ae037181b7386","883":"7899dddfc96a08309768"}[chunkId] + ".js";
};